export function pathRemovingBasePath(path, basePath) {
  if (path.startsWith("".concat(basePath, "/"))) {
    return path.slice(basePath.length);
  }
  if (path === basePath) {
    return '/';
  }
  return path;
}